/* eslint-disable */
import { Grid, Skeleton, Typography } from '@mui/material';
import React from 'react';

const SkeletonListing = () => {
    return (
        <Grid container spacing={2} sx={{ margin: 'unset', marginTop: 0, width: '100%' }}>
            <Grid item xs={12}>
                <Skeleton width="30%" height={300} />
            </Grid>
            <Grid container spacing={2} marginTop={2}>
                <Grid item xs={12} sm={4}>
                    <Skeleton width="100%" height={30} />
                    <Skeleton width="100%" height={30} />
                    <Skeleton width="100%" height={30} />
                    <Skeleton width="100%" height={30} />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Skeleton width="100%" height={30} />
                    <Skeleton width="100%" height={30} />
                    <Skeleton width="100%" height={30} />
                    <Skeleton width="100%" height={30} />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Skeleton width="100%" height={30} />
                    <Skeleton width="100%" height={30} />
                    <Skeleton width="100%" height={30} />
                    <Skeleton width="100%" height={30} />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default SkeletonListing;
